import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import { AppShell } from "@components/shell/AppShell";
import { WellExplorer } from "@features/wellExplorer/WellExplorer";
import { WellRecord } from "@features/wellRecord/WellRecord";
import { DailyReport } from "@features/dailyReport/DailyReport";
import { TimeNpt } from "@features/timeNpt/TimeNpt";
import { CostAfe } from "@features/costAfe/CostAfe";
import { Mud } from "@features/mud/Mud";
import { Tubulars } from "@features/tubulars/Tubulars";
import { Surveys } from "@features/surveys/Surveys";
import { Hse } from "@features/hse/Hse";
import { Bha } from "@features/bha/Bha";
import { PicklistAdmin } from "@features/picklists/PicklistAdmin";
import { AnalyticsHome } from "@features/analytics/AnalyticsHome";
import { ExportRoute } from "@features/export/ExportRoute";
import { Placeholder } from "@components/Placeholder";
import { AuthCallback } from "@features/auth/AuthCallback";
import "@features/auth/auth.css";

const router = createBrowserRouter([
  // OIDC callback lands OUTSIDE the shell — there is no session yet when the
  // broker redirects the user back here with ?code=…&state=….
  { path: "/auth/callback", element: <AuthCallback /> },
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/wells" replace /> },
      { path: "wells", element: <WellExplorer /> },
      { path: "well", element: <WellRecord /> },
      { path: "daily", element: <DailyReport /> },
      { path: "time-npt", element: <TimeNpt /> },
      { path: "cost-afe", element: <CostAfe /> },
      { path: "bha", element: <Bha /> },
      { path: "tubulars", element: <Placeholder titleKey="nav.tubulars" /> },
      { path: "mud", element: <Mud /> },
      { path: "tubulars", element: <Tubulars /> },
      { path: "mud", element: <Placeholder titleKey="nav.mud" /> },
      { path: "hse", element: <Placeholder titleKey="nav.hse" /> },
      { path: "surveys", element: <Surveys /> },
      { path: "hse", element: <Hse /> },
      { path: "surveys", element: <Placeholder titleKey="nav.surveys" /> },
      { path: "inbox", element: <Placeholder titleKey="nav.inbox" /> },
      { path: "saved", element: <AnalyticsHome /> },
      { path: "export", element: <ExportRoute /> },
      { path: "admin/picklists", element: <PicklistAdmin /> },
      { path: "*", element: <Navigate to="/wells" replace /> },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
